export const SITE_URL = "https://axorapsglobal.com";

export const WHATSAPP_LINK =
    "https://wa.me/919602655086?text=Hello%20Axora%20PS%20Global%20LLP%2C%20I%20am%20interested%20in%20Rapeseed%2FMustard%20DOC.%20Please%20share%20specifications%2C%20COA%20support%2C%20pricing%2C%20and%20shipment%20terms.";

export const WHATSAPP_LINK_SUSHANT =
    "https://wa.me/917340211436?text=Hello%20Axora%20PS%20Global%20LLP%2C%20I%20am%20interested%20in%20Rapeseed%2FMustard%20DOC.%20Please%20share%20specifications%2C%20COA%20support%2C%20pricing%2C%20and%20shipment%20terms.";

export const COMPANY = {
    name: "AXORA PS GLOBAL LLP",
    type: "Merchant Exporter LLP",
    location: "Jaipur, Rajasthan, India",
    gst: "08ACOFA1315L1ZB",
    iec: "ACOFA1315L",
    email: "sales@axorapsglobal.com",
    phone: "+91 9602655086",
    address: "2nd Floor, Plot No. D/12/A, RPA Road, Shastri Nagar, Jaipur, Rajasthan 302016, India",
    hours: "Monday–Sunday, 10:00 AM–8:00 PM IST",
    founders: [
        {
            name: "Puneet Aggarwal",
            role: "Co-Founder",
            phone: "+91 9602655086",
            whatsapp: WHATSAPP_LINK,
            email: "sales@axorapsglobal.com",
        },
        {
            name: "Sushant Lohia",
            role: "Co-Founder",
            phone: "+91 7340211436",
            whatsapp: WHATSAPP_LINK_SUSHANT,
            email: "sales@axorapsglobal.com",
        },
    ],
};

export const NAV = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about" },
    { label: "Products", path: "/products" },
    { label: "DOC Specifications", path: "/products/rapeseed-mustard-doc" },
    { label: "Export Process", path: "/export-process" },
    { label: "Markets", path: "/markets" },
    { label: "Compliance", path: "/compliance" },
    { label: "Contact", path: "/contact" },
];

export const PORTS = ["Mundra", "Kandla/Deendayal", "JNPT/Nhava Sheva", "Pipavav", "Hazira"];

export const HSN_NOTE =
    "HSN codes are provided for buyer reference only and should be verified against the final product form and customs classification.";

export const COMPLIANCE_DISCLAIMER =
    "Product specifications, documentation, shipment terms, and availability are subject to final contract, buyer requirements, batch-wise quality results, and applicable export/import regulations. HSN codes are provided for buyer reference only and should be verified against the final product form and customs classification.";
